const routes = [
    {
        path: "/bulk/import",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
